import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cp0007',
    ecrans: ['00-2'],
    params: ['?pflcleint']
});
